module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Music-cloud-ccc45d85242f648a0f97e6dfd91f4554.svg";